import React from 'react';
import {observer} from 'mobx-react';
import GlobalSearchState from 'global_search/state/GlobalSearchState';
import globalSearchStore from 'stores/global_search/GlobalSearchStore';
import {SearchableDropdown} from 'components';
/*global window*/

@observer class GlobalSearchContainer extends React.Component {
  handleSelect = (viewModel) => {
    if (viewModel && viewModel.data && viewModel.data.link) {
      window.location = viewModel.data.link;
    }
  };

  render() {
    const {uiState} = this.props;

    return (
      <SearchableDropdown
        suggestions={uiState.sections}
        onQueryChange={(query) => uiState.updateQuery(query)}
        onSelect={this.handleSelect}
      />
    );
  }
}

export default () => {
  const uiState = new GlobalSearchState(globalSearchStore);
  return <GlobalSearchContainer uiState={uiState}/>;
};
